<template>
  <v-container fluid class="pa-6">
    <DashboardFilters ref="dashboardFilters" :is-loading="isRefreshing" @draft-change="onFiltersDraftChange"
      @apply="onFiltersApply" @refresh="onFiltersRefresh" />

    <v-row class="mb-6">
      <v-col v-for="card in metricCardConfig" :key="card.key" cols="12" sm="6" md="4" lg>
        <MetricCard :title="card.title" :icon="card.icon" :icon-color="card.color" :metric-key="card.key"
          :metric-data="metrics[card.key]" :metric-status="metricStatus[card.key]"
          :is-comparison-active="isComparisonActive" :cards-loading="cardsLoading"
          :show-partial-activation="false"
          :supports-activation="card.supportsActivation" :activation-route="card.activationRoute"
          :value-formatter="card.valueFormatter" :comparison-value="filterValues.compare" />
      </v-col>
    </v-row>

    <DashboardGraph ref="dashboardGraph" :metrics="metrics" />
    <PActionDialog v-model="dialog.show" :type="dialog.type" :user-name="userName" />
    <QuickStartPopup v-model="quickStart.show" :entry-mode="quickStartEntryMode" @close="onQuickStartClose" />
  </v-container>
</template>

<script>
import dashboardMixin from '@/mixins/dashboard'
import DashboardFilters from './dashboard/DashboardFilters.vue'
import MetricCard from '@/components/dashboard/MetricCard.vue'
import DashboardGraph from '@/components/dashboard/DashboardGraph.vue'
import PActionDialog from '@/components/pricing/PActionDialog'
import QuickStartPopup from '@/components/dashboard/QuickStartPopup'
import { ACTION_DIALOG_TYPES } from '@/shared/constants/pricing/data'

export default {
  name: 'Dashboard',
  mixins: [dashboardMixin],
  components: {
    DashboardFilters,
    MetricCard,
    DashboardGraph,
    PActionDialog,
    QuickStartPopup
  },
  data() {
    return {
      dialog: {
        show: false,
        type: null
      },
      quickStart: {
        show: false
      }
    }
  },
  computed: {
    userName() {
      return this.user?.name?.split(' ')[0] || null
    },
    shouldShowDialog() {
      return !this.isAdmin && !this.isSuperCustomer
    },
    shouldShowQuickStart() {
      return !!this.user && !this.isAdmin && !this.user.quick_start_seen_at
    },
    quickStartEntryMode() {
      if (this.shouldShowQuickStart) {
        return 'full'
      }
      return this.$route.query.quickstart === 'video' ? 'video-only' : 'full'
    }
  },
  mounted() {
    if (this.shouldShowDialog) {
      this.determineDialogType()
    }
    if (this.shouldShowQuickStart || this.$route.query.quickstart) {
      this.quickStart.show = true
    }
  },
  methods: {
    determineDialogType() {
      // Priority: Account Expired > Trial Ended > Past Due
      if (this.userMixin_hasActiveFreePlan || (this.userMixin_hasActiveFreeTrialPlan && this.userMixin_accountExpired)) {
        this.openDialog(ACTION_DIALOG_TYPES.ACCOUNT_EXPIRED)
      } else if (this.userMixin_trialEnded) {
        this.openDialog(ACTION_DIALOG_TYPES.TRIAL_ENDED)
      } else if (this.userMixin_isPastDueUser) {
        this.openDialog(ACTION_DIALOG_TYPES.PAST_DUE)
      }
    },
    openDialog(type) {
      this.dialog.type = type
      this.dialog.show = true
    },
    onQuickStartClose() {
      this.quickStart.show = false
      if (this.$route.query.quickstart) {
        this.$router.replace({ query: {} })
      }
      if (!this.user?.quick_start_seen_at) {
        this.$store.dispatch('user/markQuickStartSeen', { userId: this.user.id })
      }
    }
  },
  watch: {
    '$route.query.quickstart'(val) {
      if (val) {
        this.quickStart.show = true
      }
    }
  }
}
</script>
